import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-community-home',
  templateUrl: './community-home.component.html',
  styleUrls: ['./community-home.component.scss']
})
export class CommunityHomeComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }

  public theme = environment.theme_config;

  ngOnInit() {
    this.route.fragment.subscribe(f => {
      setTimeout(() => {
        const element = document.querySelector("#" + f);
        if (element) {
          const offset = -100;
          const y = element.getBoundingClientRect().top + window.pageYOffset + offset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 250)
    })
  }

}
